var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("You have been assigned as an "),_c('b',[_vm._v(_vm._s(_vm.value.event.payload.new_role))]),_vm._v(" for content "),_c('b',[_vm._v(_vm._s(_vm.custom_id))])])
}
var staticRenderFns = []

export { render, staticRenderFns }